import { Link, useLocation } from "react-router-dom";
import Container from "@/components/base/Container";
import Seo from "@/components/feature/Seo";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { navLinks } from "@/mocks/site";

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <Seo
        title="页面不存在 - 深瓜社"
        description="你访问的页面不存在或已经被移动。回到首页或瓜田，继续浏览热门大瓜深扒、未删减原稿与完整时间线。"
        keywords="热门大瓜,大瓜深扒,完整时间线,页面不存在"
        path="/404"
      />
      <SiteHeader />
      <main>
        <Container className="flex min-h-[65vh] flex-col items-center justify-center py-20 text-center">
          <p className="font-heading text-[80px] font-black leading-none text-background-300 md:text-[120px]">
            404
          </p>
          <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            这条时间线上没有这一格
          </h1>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
            你访问的地址 {location.pathname} 不存在，可能是链接有一处笔误，或者这篇整理稿已经被合并。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/"
              className="inline-flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-home-4-line"></i>
              回到首页
            </Link>
            <Link
              to="/topics"
              className="inline-flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-plant-line"></i>
              进入瓜田
            </Link>
          </div>

          <div className="mt-12 flex flex-wrap justify-center gap-x-6 gap-y-3 border-t border-background-200 pt-8 text-sm">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="text-foreground-600 transition-colors hover:text-primary-700"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </Container>
      </main>
      <SiteFooter />
    </>
  );
}